import { Controller } from "@hotwired/stimulus"

/**
 * WindowEventDispatcher Controller
 *
 * Dispatches a window-level CustomEvent when an element is interacted with.
 * Useful for triggering behavior owned by a Stimulus controller mounted
 * elsewhere in the DOM tree without coupling the trigger to its target.
 *
 * Dispatches on `window` by default. Set `event-target-value="document"` when
 * the listening controller binds the event on `document` instead (a CustomEvent
 * dispatched on `window` does not reach `document`-level listeners).
 *
 * Usage:
 *   <button data-controller="window-event-dispatcher"
 *           data-window-event-dispatcher-event-name-value="persistent-dismissable:toggle"
 *           data-window-event-dispatcher-detail-value='{"key":"my_banner"}'
 *           data-action="click->window-event-dispatcher#dispatch">
 *     Toggle
 *   </button>
 */
export default class extends Controller {
  static values = {
    eventName: String,
    detail: { type: Object, default: {} },
    eventTarget: { type: String, default: "window" }
  }

  dispatch() {
    const target = this.eventTargetValue === "document" ? document : window
    target.dispatchEvent(new CustomEvent(this.eventNameValue, { detail: this.detailValue }))
  }
}
